(() => {
  'use strict';

  if (customElements.get('dieux-repurpose-impact')) return;

  const EXPLAINER_ORIGIN = 'https://app.repurpose.global';

  class DieuxRepurposeImpact extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.sustainabilityVariantIds = new Set(
        (this.dataset.sustainabilityVariantIds || '').split('|').filter(Boolean)
      );

      document.addEventListener(
        'dieux:product-variant-change',
        (event) => this.handleVariantChange(event),
        { signal }
      );

      this.explainer = document.getElementById(this.dataset.explainerId || '');
      if (this.explainer) {
        this.explainer.addEventListener('dieux:dialog:open', () => this.loadExplainer(), { signal });
        window.addEventListener('message', (event) => this.handleExplainerMessage(event), { signal });
      }

      this.selectVariant(this.dataset.activeVariantId);

      this.visibilityObserver?.disconnect();
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.toggleAttribute('data-offscreen', !entry.isIntersecting);
      });
      this.visibilityObserver.observe(this);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      this.explainer = null;
    }

    get explainerFrame() {
      return this.explainer?.querySelector('[data-repurpose-explainer-frame]') || null;
    }

    handleVariantChange(event) {
      if (String(event.detail?.productId || '') !== String(this.dataset.productId || '')) return;
      this.selectVariant(event.detail?.variant?.id);
    }

    selectVariant(variantId) {
      const nextVariantId = String(variantId || '');
      const hasSustainability = this.sustainabilityVariantIds.has(nextVariantId);
      const shouldShow = this.dataset.placement === 'sustainability'
        ? hasSustainability
        : !hasSustainability;

      this.dataset.activeVariantId = nextVariantId;
      this.hidden = this.dataset.enabled !== 'true' || !shouldShow;
    }

    loadExplainer() {
      const frame = this.explainerFrame;
      if (!frame || frame.src || !frame.dataset.src) return;
      frame.src = frame.dataset.src;
    }

    handleExplainerMessage(event) {
      if (event.origin !== EXPLAINER_ORIGIN || event.data?.type !== 'RPG_CLOSE_MODAL') return;
      const frame = this.explainerFrame;
      if (!frame || event.source !== frame.contentWindow) return;
      this.explainer.close();
    }
  }

  customElements.define('dieux-repurpose-impact', DieuxRepurposeImpact);
})();
